/* eslint-disable no-async-promise-executor */
import axios from 'axios';
import Config from 'root/common/config/config';
import { getAppIDInfo } from 'root/common/nativeApi/index';
import { EventBus } from 'root/common/EventBus';
import { isGreaterVersion, log, isArray, getCookie, isDev } from 'root/common/util/index';
import storage from 'root/common/util/storage';
import loginState, { isNewVersion } from 'root/common/util/getLoginState';
import { globalGetUserCity } from './util/userPosition';
import locationUtil from 'root/blackcard/util/location/locationUtil';
import fixUserId from 'root/common/util/fixUserId';
import { getQueryFromQuery } from 'root/common/util/url';
import { isVisitor } from 'root/common/util/visitor';
import env from '@/common/util/env';

// import * as nativeApi from 'root/blackcard/nativeApi/index';

let Loading_Request_Count = 0; // loading统计次数
const isAPP = window.__is_blackApp;
const ZZCFL = window.ZZCFL;
const zzc = window.zzc;
let isQueuing = false;
let getTokenQueue = [];
let black_token = null;
let isNative =
    isAPP &&
    isGreaterVersion({
        iosMinVersion: '1.21.0',
        androidMinVersion: '1.21.0',
        harmonyVersion: '1.0.0',
    }); // 判断是否原生化

const service = axios.create({
    timeout: 20000, // request timeout
});
let isTryToUseNativeToken = false; // token过期的时候判断是否已经用过原生的token，没过期试一下用原生的，如果还是过期，走以前逻辑。
const search = window.location.href.split('?');
const query = getQueryFromQuery(search.length > 0 ? search[1] : window.location.search);

// 判断是否游客模式
initLoginWall();
// 修复用户id
fixUserId();

// 配置办卡链接
initLoginWallCardLink();

/**
 * 是否是java接口
 * @param {string} url
 */
function isMatchJava(url) {
    return url.match(Config.domain) || url.match(Config.fanxianDomain);
}

service.interceptors.request.use(
    async config => {
        // Do something before request is sent

        // 测试环境且cookie中env有值
        if (isDev() && getCookie('env')) {
            // lbsDomain都是固定生产环境的，如果带了'Use-Env'headers，会导致跨域，针对该域名的请求不添加'Use-Env'headers
            if (!config.url.match(Config.lbsDomain)) {
                config.headers['Use-Env'] = getCookie('env');
            }
        }

        if (config.isNeedToken) {
            const token = localStorage.getItem('token');
            config.headers.token = token;
        }

        if (
            config.url.match(Config.blackCardDomain) ||
            config.isMultiDomain ||
            config.url.match(Config.privilegeDomain) ||
            config.url.match(Config.privilegeApiDomain) ||
            config.url.match(Config.facadeDomain) ||
            config.url.match(Config.adsDomain)
        ) {
            if (!black_token) {
                black_token = await getBlackToken();
            }
            if (black_token) {
                config.headers['black-token'] = black_token;
            }
        }

        if (config.needPageUrl) {
            config.headers['path-url'] = location.href;
            config.headers['target-url'] = sessionStorage.getItem('targetUrl');
            config.headers['user-id'] = localStorage.getItem('userId');
        }

        // 商家券请求头加字段
        // 如果在小程序环境，判断是否有提供小程序环境参数miniEnv
        try {
            if (env.isWechatMini && isMatchJava(config.url)) {
                const miniEnvJson = window.localStorage.getItem('miniEnv');
                if (miniEnvJson) {
                    const miniEnv = JSON.parse(miniEnvJson);
                    config.headers['miniAppId'] = miniEnv.appId;
                    config.headers['miniOpenId'] = miniEnv.openId;
                    config.headers['wxUnionId'] = miniEnv.unionId;
                }
            }
        } catch (err) {
            // xx
        }

        // 针对java接口
        if (isMatchJava(config.url)) {
            // 针对app，获取机器码给后端
            if (isAPP) {
                let IDINFO = window.localStorage.getItem('IDINFO');
                if (IDINFO) {
                    IDINFO = JSON.parse(IDINFO);
                    if (IDINFO.IDFA) {
                        config.headers['device-type'] = 'IDFA';
                        config.headers['device-value'] = IDINFO.IDFA;
                    } else if (IDINFO.UTDID) {
                        config.headers['device-type'] = 'UTDID';
                        config.headers['device-value'] = IDINFO.UTDID;
                    }
                } else {
                    try {
                        const info = await getAppIDInfo();
                        IDINFO = info;

                        if (IDINFO) {
                            if (IDINFO.IDFA || IDINFO.UTDID) {
                                window.localStorage.setItem('IDINFO', JSON.stringify(IDINFO));
                            }
                            if (IDINFO.IDFA) {
                                config.headers['device-type'] = 'IDFA';
                                config.headers['device-value'] = IDINFO.IDFA;
                            } else if (IDINFO.UTDID) {
                                config.headers['device-type'] = 'UTDID';
                                config.headers['device-value'] = IDINFO.UTDID;
                            }
                        }
                    } catch (error) {
                        console.error(error);
                    }
                }
            }
            // 是否新用户
            const newcomer = storage.get(storage.keys.isNewUser);
            let isNew = newcomer !== false && newcomer !== '0';
            if (!loginState()) isNew = true;
            config.headers['newcomer'] = isNew.toString();
            if (localStorage.getItem('member_id')) {
                config.headers['phpUserId'] = localStorage.getItem('member_id');
            }
        }

        try {
            if (config.isNeedPosition) {
                // 如果3s都没反应，则取默认
                let positionObj = locationUtil.getPositionCityCache();
                let chooseObj = locationUtil.getChooseCityCache();

                // 如果定位缓存没有或者已过14天，则需要重新获取
                let isNeedGetLoactiaon =
                    !positionObj ||
                    !positionObj.timestamp ||
                    new Date().getTime() - positionObj.timestamp > 14 * 3600 * 1000;
                if (chooseObj) {
                    // 默认拿选择过的地址
                    config.headers['cityLocationId'] = chooseObj.id;
                } else if (isNeedGetLoactiaon) {
                    // 同时，判断是否24小时内已经发生失败获取地址的情况，如果失败过，则不传cityID了
                    if (!storage.get(storage.keys.getUserLocationFailFlag)) {
                        let result = null;
                        result = await globalGetUserCity();
                        if (result) config.headers['cityLocationId'] = result.id;
                    }
                } else {
                    // 拿定位缓存
                    config.headers['cityLocationId'] = positionObj.id;
                }
            }
        } catch (error) {
            console.error('location error', error);
        }
        // if (process.env.NODE_ENV == 'development') config.headers.isDev = 'dev';
        log('请求config', config);
        return config;
    },
    error => Promise.reject(error)
);

service.interceptors.response.use(
    response => Promise.resolve(response),
    error => Promise.reject(error)
);

/**
 *
 *
 * @param {*} {
 *   url,
 *   method='get',
 *   isNeedLoading=true, //是否开启loading
 *   isNeedToken=true, //默认需要token参数
 *   loadingText='加载中..',
 *   isShowCatchErr=true,//默认显示catch错误异常
 *   ...option
 * }
 * @returns
 */
async function request({
    url,
    method = 'get',
    isNeedLoading = true,
    isNeedToken = true,
    isNeedPosition = false,
    loadingText = '加载中..',
    isShowCatchErr = true,
    isNoCache = false, // 是否强制不用缓存，保证每次都是最新内容
    needPageUrl = false, // 接口header是否需要显示页面url
    isMultiDomain = false, // 是否骑士卡的多域名
    isNeedLog = false, // 是否需要上报接口参数、响应参数
    excludeArmsErrorCode = [], // arms errorCode上报白名单
    ...option
}) {
    log(`请求${method}:${url}`);
    if (isNoCache) {
        let params = option.params ? option.params : {};
        option.params = { ...params, _t: new Date().getTime() };
    }

    const param = {
        url,
        method,
        ...option,
    };

    return new Promise(async (resolve, reject) => {
        service.defaults.isNeedToken = isNeedToken;
        service.defaults.url = url;
        service.defaults.needPageUrl = needPageUrl;
        service.defaults.isMultiDomain = isMultiDomain;
        service.defaults.isNeedPosition = isNeedPosition;
        service.defaults.isNeedLog = isNeedLog;
        service.defaults.excludeArmsErrorCode = excludeArmsErrorCode;
        if (isNeedToken && !localStorage.getItem('token')) {
            // 如果result 为 false， 没有登录
            if (isQueuing) {
                getTokenQueue.push(({ option }) => {
                    // 只处理是登陆墙页面并且是400错误的接口
                    if (checkIsLoginWallPage() && lessBadRequest(param.url)) {
                        console.log('登陆墙接口~拦截了');
                        return false;
                    }
                    request(
                        Object.assign(
                            param,
                            {
                                isNeedLoading,
                                isNeedToken,
                                loadingText,
                                isShowCatchErr,
                                isNoCache,
                                isNeedLog,
                                excludeArmsErrorCode,
                            },
                            option
                        )
                    )
                        .then(res => {
                            resolve(res);
                        })
                        .catch(err => {
                            reject(err);
                        });
                });

                console.log(getTokenQueue);

                return false;
            }

            // 阻止后面的继续获取token
            isQueuing = true;
            let result;
            try {
                result = await getAuthToken();
            } catch (error) {
                console.log('error:', error);
                // 增加接口监控
                window.monitor &&
                    window.monitor.report({
                        level: 'error',
                        error: 'api',
                        url: location.href,
                        msg: '获取token进入了catch错误',
                    });
            }

            // result 为 false 登陆墙, 没有token
            // result 为 undefined 即为进入了catch逻辑，后台接口报非507错误，或者超时等错误
            if (!(checkIsLoginWallPage() && lessBadRequest(param.url))) {
                request(
                    Object.assign(param, {
                        isNeedLoading,
                        isNeedToken: result || false, // 处理 result 为 undefined 情况，防止再起发起请求读取 isNeedToken 的默认值 true，导致进入死循环。
                        loadingText,
                        isShowCatchErr,
                        isNoCache,
                        isNeedLog,
                        excludeArmsErrorCode,
                    })
                )
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            }

            // 获取完解除限制
            isQueuing = false;

            getTokenQueue.forEach(fn => {
                let option = {
                    isNeedToken: result || false, // 处理 result 为 undefined 情况，防止再起发起请求读取 isNeedToken 的默认值 true，导致进入死循环。
                };
                fn({
                    option,
                });
            });

            getTokenQueue = [];
        } else {
            // 是否上报接口参数
            if (isNeedLog) {
                window.monitor &&
                    window.monitor.report({
                        level: 'info',
                        url: window.location.href,
                        msg: `接口:${url},上报请求参数`,
                        stack: JSON.stringify({ param }),
                    });
            }
            // 检测是否开启loading， 统计为0时才启动loading
            if (isNeedLoading) {
                if (Loading_Request_Count == 0) ZZCFL.Loading.open(loadingText);
                ++Loading_Request_Count;
            }
            service(param)
                .then(async res => {
                    log(`请求${param.method}:${param.url}`, param, res.data);
                    // 是否上报接口响应参数
                    if (isNeedLog) {
                        window.monitor &&
                            window.monitor.report({
                                level: 'info',
                                url: window.location.href,
                                msg: `接口:${url},上报响应参数`,
                                stack: JSON.stringify({ param, res }).slice(0, 1024), //最大值 17000左右
                            });
                    }
                    // 处理需要跳转登录的状态码 （for黑卡)
                    if (
                        ((param.url.match(Config.blackCardDomain) || isMultiDomain) &&
                            (res.data.code === 3306 || res.data.code === 111)) ||
                        (param.url.match(Config.privilegeApiDomain) && res.data.code === 122)
                    ) {
                        if (checkIsLoginWallPage()) return false;

                        resetStatus();
                        if (isAPP && zzc) {
                            goAppIndexPage();
                            if (window.monitor) {
                                // 增加接口监控
                                window.monitor.report({
                                    level: 'error',
                                    error: 'api',
                                    url: param.url,
                                    msg: 'getAuthToken1:' + res.data.code + '||' + Config.blackCardDomain,
                                });
                            }
                            return false;
                        }
                        linkToLogin();
                        return false;
                    }

                    // 处理需要跳转登录的状态码 （for商城Api)
                    if (
                        (res.data.code === 502 || res.data.code === 503 || res.data.code === 507) &&
                        isMatchJava(param.url) &&
                        param.url != Config.api.getAppToken &&
                        param.url != Config.api.getToken
                    ) {
                        if (!checkIsLoginWallPage()) {
                            if (window.monitor) {
                                // 增加接口监控
                                window.monitor.report({
                                    level: 'error',
                                    error: 'api',
                                    url: param.url,
                                    msg: `非token接口重定向登录:
                                        ${param.url}
                                        postData:-> ${JSON.stringify(param.data)}
                                        getParam:-> ${JSON.stringify(param.params)}
                                        res:-> ${JSON.stringify(res.data)}
                                        ||
                                        ${localStorage.getItem('token')}`,
                                });

                                // 开红包埋错误日志
                                if (param.url.match('redPacket/v1_0/openRedPacket')) {
                                    window.monitor.report({
                                        level: 'error',
                                        error: 'api',
                                        url: param.url,
                                        msg:
                                            '开红包token错误: || 请求参数' +
                                            JSON.stringify(param.data) +
                                            JSON.stringify(res.data) +
                                            '||' +
                                            localStorage.getItem('token'),
                                    });
                                }
                            }

                            resetStatus();
                            if (isAPP && zzc) {
                                goAppIndexPage();
                                return false;
                            }
                            linkToLogin();
                            return false;
                        }
                    }

                    // code为!0和!200的时候上报错误
                    // 地址接口，用了大写的Code...
                    if (res.data.code != 0 && res.data.code != 200 && res.data.Code != 0) {
                        let paramStr = '';
                        try {
                            paramStr = JSON.stringify(param);
                        } catch {
                            paramStr = '';
                        }
                        if (window.monitor) {
                            window.monitor.report({
                                level: 'error',
                                error: 'api',
                                url: param.url,
                                // msg: res.data.msg,
                                msg: `接口异常上报: ${param.url}
                                postData:-> ${JSON.stringify(param.data)}
                                getParam:-> ${JSON.stringify(param.params)}
                                res:-> ${JSON.stringify(res.data)}
                                time:-> ${new Date()}
                                token:-> ${localStorage.getItem('token')}
                                phpToken:->${localStorage.getItem('dolphin_token_from_jssdk') ||
                                    localStorage.getItem('dolphin_token')}`,
                                stack: paramStr,
                            });
                        }
                        if (window.__bl && window.__bl.api) {
                            if (
                                excludeArmsErrorCode &&
                                isArray(excludeArmsErrorCode) &&
                                excludeArmsErrorCode?.includes(Number(res.data?.code))
                            ) {
                                const begin = Date.now();
                                window.__bl.api({
                                    api: res.config.url,
                                    success: true,
                                    time: Date.now() - begin,
                                    code: res.status,
                                });
                            } else {
                                const { traceId } = res.config.headers;
                                const begin = Date.now();
                                // 接口请求成功，但后端返回错误code上报
                                window.__bl.api({
                                    api: res.config.url,
                                    success: false,
                                    time: Date.now() - begin,
                                    code: res.status,
                                    msg: `接口异常上报: ${res.data?.code}: ${res.data?.msg}`,
                                    begin,
                                    traceId,
                                });
                            }
                        }

                        if (param.url.match('knightCard/goods/v1_0/tbk/goodsDetail')) {
                            window.monitor.report({
                                level: 'error',
                                error: 'api',
                                url: param.url,
                                msg: `淘宝客详情页错误: ${param.url}
                                href:->${location.href}
                                leaderInfo:->${localStorage.getItem('leaderInfo')}
                                selectAllTabABTest:->${localStorage.getItem('selectAllTabABTest')}
                                paramsPass:->${localStorage.getItem('paramsPass')}`,
                            });
                        }
                    } else {
                        if (window.__bl && window.__bl.api) {
                            const begin = Date.now();
                            window.__bl.api({
                                api: res.config.url,
                                success: true,
                                time: Date.now() - begin,
                                code: res.status,
                            });
                        }
                    }

                    resolve(
                        Object.assign(
                            {
                                res,
                                ...res.data,
                            },
                            {
                                tokenStatus: localStorage.getItem('token') ? true : false,
                            }
                        )
                    );

                    // loading为0时才关闭loading
                    if (isNeedLoading) closeLoading();
                })
                .catch(async err => {
                    console.log(err);
                    if (err.message != 'cancel') {
                        reject(err);
                        if (isShowCatchErr) ZZCFL.Toast('网络异常，请重试');
                        // loading为0时才关闭loading
                    }
                    if (isNeedLoading) closeLoading();
                });
        }
    }).catch(error => {
        // 增加接口监控
        if (window.monitor) {
            error = error || {};
            let errorConfig = error.config || {};
            window.monitor.report({
                level: 'error',
                error: 'api',
                url: errorConfig.url,
                msg: JSON.stringify({
                    msg: error.message,
                    params: errorConfig.params || '',
                    data: errorConfig.data || '',
                }),
                stack: error.stack,
            });
        }
        if (window.__bl && window.__bl.api) {
            const begin = Date.now();
            let errorConfig = error.config || {};

            // 接口错误上报
            window.__bl.api({
                api: url,
                success: false,
                time: Date.now() - begin,
                code: errorConfig.status,
                msg: `${errorConfig.status}: ${error.stack}`,
                begin,
            });
        }
        return Promise.reject(error);
    });
}

function closeLoading() {
    setTimeout(() => {
        --Loading_Request_Count;
        if (Loading_Request_Count <= 0) ZZCFL.Loading.close();
    }, 200);
}

/**
 * 请求token接口
 *
 * @date 2019-04-09
 * @param {*} { url, data }
 * @param {*} resolve
 * @param {*} reject
 * @param {*} logFn
 * @param {*} successFn
 */
function handleTokenResult({ url, data, resolve, reject, logFn, successFn, failFn, completeFn }) {
    // 游客模式不获取token
    if (isAPP && (localStorage.getItem('loginwall') || isVisitor())) {
        resolve(false);
        return false;
    }
    request({
        url,
        method: 'post',
        data,
        isNeedToken: false,
        isNeedLoading: false,
        needPageUrl: true,
        isShowCatchErr: false,
    })
        .then(res => {
            if (completeFn) completeFn();
            if (res.code === 200) {
                if (successFn) successFn();
                setToken(res.data.token, res.data.userId);
                resolve(true);
                isTryToUseNativeToken = false; // 设置成功后，恢复设置
            } else if (res.code === 507) {
                if (checkIsLoginWallPage()) {
                    resolve(false);
                    return false;
                }
                resetStatus();
                if (isAPP && zzc) {
                    goAppIndexPage();
                    if (window.monitor) {
                        // 增加接口监控
                        logFn();
                    }
                    return false;
                }
                linkToLogin();
            } else {
                ZZCFL.Toast(res.msg);
                if (failFn) failFn();
                reject();
            }
        })
        .catch(() => {
            if (failFn) failFn();
            if (completeFn) completeFn();
            reject();
        });
}

/**
 * 获取token
 *
 * @param {*} code
 * @returns
 */
function getAuthToken() {
    let codeStorage = sessionStorage.getItem('code');
    let code = null;

    if (codeStorage) {
        codeStorage = JSON.parse(codeStorage);
        // is_used: 0: 还没使用 1: 已成功 2: 失败 3: 正在使用
        if (codeStorage.is_used == 0) {
            code = codeStorage.code;
            sessionStorage.setItem('code', `{"code": "${code}", "is_used": 3}`);
        }
    }

    return new Promise(async (resolve, reject) => {
        // 判断是否能拿到php返回的token
        let token = localStorage.getItem('dolphin_token_from_jssdk') || localStorage.getItem('dolphin_token');

        // 原生化直接读取原生缓存
        if (isNative && !isTryToUseNativeToken) {
            let data = await getNativeToken();
            if (data) {
                // 如果返回了phpToken, javaToken,便进行登录。如果原生返回的也是过期的，会根据isTryToUseNativeToken判断第二次进来，下面的函数，重新获取token。
                isTryToUseNativeToken = true;
                resolve(true);
                return false;
            }
        }
        if (token) {
            handleTokenResult({
                url: Config.api.getAppToken,
                data: {
                    code,
                    phpToken: token,
                    sign: 'string',
                },
                resolve,
                reject,
                logFn: () => {
                    window.monitor.report({
                        level: 'error',
                        error: 'api',
                        url: Config.api.getAppToken,
                        msg: 'getAuthToken4:' + token + '*' + window.navigator.userAgent,
                    });
                },
                successFn: () => {
                    if (code) {
                        // is_used: 0: 还没使用 1: 已成功 2: 失败 3: 正在使用
                        sessionStorage.setItem('code', `{"code": "${code}", "is_used": 1}`);
                    }
                },
                failFn: () => {
                    if (code) {
                        // is_used: 0: 还没使用 1: 已成功 2: 失败 3: 正在使用
                        sessionStorage.setItem('code', `{"code": "${code}", "is_used": 2}`);
                    }
                },
            });

            // 读取原生储存的token
        } else if (isAPP && window.zzc && window.zzcjsbridge && window.zzcjsbridge.account_getInfo) {
            window.zzc.call('account_getInfo', {
                success: function(response) {
                    log('account_getInfo success 594', response);
                    if (response.data) {
                        handleTokenResult({
                            url: Config.api.getAppToken,
                            data: {
                                phpToken: response.data.token,
                                sign: 'string',
                            },
                            resolve,
                            reject,
                            logFn: () => {
                                window.monitor.report({
                                    level: 'error',
                                    error: 'api',
                                    url: Config.api.getAppToken,
                                    msg: 'getAuthToken4_app:' + response.data.token + '*' + window.navigator.userAgent,
                                });
                            },
                        });
                    } else {
                        reject();
                    }
                },
            });

            // cookie授权流程
            // 低版本未登陆过app, 会不存在token
        } else {
            const session = ZZCFL.Utils.Cookie.get('dolphin_session');
            window.monitor.report({
                level: 'error',
                error: 'api',
                url: Config.api.getToken,
                msg: 'getTokenUrl:' + location.href + '||' + code + '||' + session,
            });

            handleTokenResult({
                url: Config.api.getToken,
                data: {
                    code,
                    dolphinSession: session,
                    sign: 'string',
                },
                resolve,
                reject,
                logFn: () => {
                    window.monitor.report({
                        level: 'error',
                        error: 'api',
                        url: Config.api.getToken,
                        msg: 'getAuthToken3:' + code + '||' + session,
                    });
                },
                successFn: () => {
                    if (code) {
                        // is_used: 0: 还没使用 1: 已成功 2: 失败 3: 正在使用
                        sessionStorage.setItem('code', `{"code": "${code}", "is_used": 1}`);
                    }
                },
                failFn: () => {
                    if (code) {
                        // is_used: 0: 还没使用 1: 已成功 2: 失败 3: 正在使用
                        sessionStorage.setItem('code', `{"code": "${code}", "is_used": 2}`);
                    }
                },
            });
        }
    });
}

/**
 * 获取骑士卡本地储存token
 *
 * @date 2019-04-10
 */
function getBlackToken() {
    return new Promise(async resolve => {
        let token = localStorage.getItem('dolphin_token_from_jssdk') || localStorage.getItem('dolphin_token');
        if (token) {
            resolve(token);
        } else if (isNative) {
            let result = await getNativeToken();
            if (result && result.token) {
                resolve(result.token);
            } else {
                resolve('');
            }
        } else if (isAPP && window.zzc && window.zzcjsbridge && window.zzcjsbridge.account_getInfo) {
            window.zzc &&
                window.zzc.call('account_getInfo', {
                    success: function(response) {
                        log('account_getInfo success 685', response);
                        if (response.data) {
                            // 打点跟踪token获取情况
                            if (!response.data.token) {
                                if (window.monitor) {
                                    window.monitor.report({
                                        level: 'error',
                                        error: 'api',
                                        url: window.location.href,
                                        msg: 'misstoken:' + JSON.stringify(response.data),
                                    });
                                }
                            }
                            resolve(response.data.token);
                        }
                    },
                });
        } else {
            // 打点获取app是否加载失败
            if (window.monitor) {
                window.monitor.report({
                    level: 'info',
                    error: 'api',
                    url: window.location.href,
                    msg: 'app plugin loadfail ua:' + window.navigator.userAgent,
                });
            }

            resolve('');
        }
    });
}

// 获取原生token
function getNativeToken() {
    return new Promise(resolve => {
        if (navigator && navigator.userAgent && navigator.userAgent.match('AliBaichuan')) {
            resolve();
            return false;
        }
        document.addEventListener(
            'deviceready',
            function() {
                if (window.zzc && window.zzcjsbridge && window.zzcjsbridge.account_getInfo) {
                    window.zzc.call('account_getInfo', {
                        success: function(response) {
                            log('account_getInfo success 731', response);
                            if (response.data) {
                                // 打点跟踪token获取情况
                                let result = response.data;
                                if (
                                    result.token &&
                                    result.javaToken &&
                                    (result.userId || result.userID) &&
                                    result.javaUserId
                                ) {
                                    localStorage.setItem('dolphin_token', result.token);
                                    localStorage.setItem('token', result.javaToken);
                                    localStorage.setItem('userId', result.javaUserId);
                                    localStorage.setItem('member_id', result.userId || result.userID);
                                    resolve(result);
                                } else {
                                    if (!localStorage.getItem('loginwall')) {
                                        window.monitor.report({
                                            level: 'error',
                                            error: 'api',
                                            url: location.href,
                                            msg:
                                                '原生化，通过account_getInfo获取原生参数失败:' + JSON.stringify(result),
                                        });
                                    }

                                    resolve();
                                }
                            }
                        },
                    });
                } else {
                    resolve();
                }
            },
            false
        );
    });
}

function goAppIndexPage() {
    closeLoading();

    ZZCFL.Dialog(
        {
            title: '登录信息已过期，请重新登录',
            showCancelButton: false,
            confirmButtonText: '确认',
            cancelButtonText: '',
            closeOnClickModal: false,
        },
        /**
         * 按钮点中后的回调
         * @param  {[string]} value [description]
         * @return {[string]} 返回confirm  || cancel [description]
         */
        value => {
            if (value === 'confirm') {
                ZZCFL.Utils.Storage.setItem('isAppLogin', 0);

                request({
                    url: `${window.location.origin}/logout`,
                    data: {},
                    method: 'get',
                    isNeedToken: false,
                }).then(() => {
                    setTimeout(() => {
                        if (window.__is_blackApp) {
                            localStorage.clear();
                            //记录登陆状态
                            ZZCFL.Utils.Storage.setItem('isAppLogin', 0);
                            resetStatus();
                            log('goAppIndexPage account_logoutSuccess');
                            zzc.call('account_logoutSuccess', {
                                success: function(response) {
                                    console.log('----通知原生退出登陆----');
                                    console.log(response);

                                    setTimeout(() => {
                                        if (
                                            isGreaterVersion({
                                                iosMinVersion: '1.37.0',
                                                androidMinVersion: '1.37.0',
                                                harmonyVersion: '1.0.0',
                                            })
                                        ) {
                                            zzc.call('jumpLogin', {
                                                data: { targetUrl: location.href },
                                                success(response) {
                                                    console.log(response);
                                                },
                                            });
                                        } else {
                                            zzc.call('base_backToHome', { tabIndex: 'book' });
                                        }
                                    }, 500);
                                },
                            });
                        }
                    }, 500);
                });
            }
        }
    );
}

/**
 * 清理token和缓存
 *
 * @returns
 */
function resetStatus() {
    localStorage.removeItem('token');
    let codeStorage = sessionStorage.getItem('code');
    try {
        codeStorage = JSON.parse(codeStorage);
        // handleTokenResult 发生507跳转，不会改变codeStorage.is_used为2。 所以还是3.
        if (codeStorage && codeStorage.is_used == 3) {
            let BackCount = sessionStorage.getItem('BackCount');
            if (BackCount) sessionStorage.setItem('BackCount', parseInt(BackCount) + 1);
        } else {
            // 如果是授权页过来的，不用清除code
            sessionStorage.removeItem('code');
        }
    } catch (error) {
        console.log(error);
        sessionStorage.removeItem('code');
    }

    localStorage.removeItem('userId');
}

/**
 * 设置token
 *
 * @param {*} token
 * @param {*} auth
 */
function setToken(token, userId) {
    // 微信支付已授权的时候，赋值为1
    localStorage.setItem('token', token);
    localStorage.setItem('userId', userId);
    if (isNative) {
        log('调用 account_loginSuccess', {
            userID: localStorage.getItem('member_id'), // 用户id
            token: localStorage.getItem('dolphin_token_from_jssdk') || localStorage.getItem('dolphin_token'),
            javaToken: token,
            javaUserId: userId,
        });
        window.zzc &&
            window.zzc.call('account_loginSuccess', {
                userID: localStorage.getItem('member_id'), // 用户id
                token: localStorage.getItem('dolphin_token_from_jssdk') || localStorage.getItem('dolphin_token'),
                javaToken: token,
                javaUserId: userId,
                success: function(response) {
                    console.log('----原生登陆成功----');
                    console.log(response);
                },
            });
    }
}

/**
 * 跳转去登录黑卡
 *
 */
function linkToLogin(isGoLogin = false) {
    let url;
    let isMultiDomain = false; // 判断是否多域名

    if (!location.href.match(Config.blackCardDomain)) isMultiDomain = true;

    if (location.href.match('redirectTag=login') || isGoLogin) {
        url = `${isMultiDomain ? '' : Config.blackCardDomain}/login?refer=${encodeURIComponent(location.href)}`;
    } else {
        url = `${isMultiDomain ? '' : Config.blackCardDomain}/activate?refer=${encodeURIComponent(location.href)}`;
    }
    window.location.href = url;
}

/**
 * 跳去微信授权页面
 *
 * @returns
 */
function linkToWechatAuth(redirect_uri) {
    let targetUrl = getToWechatAuthUrl(redirect_uri);
    window.location.replace(targetUrl);
}

// 获取跳去微信授权的URL
function getToWechatAuthUrl(redirect_uri) {
    let url = encodeURIComponent(redirect_uri || window.location.href);
    // 判断是否开发、测试域名
    if (location.href.match('-m.black-unique.com')) {
        url = 'https://m.black-unique.com/new/jump.html?isAuth=1&redirectUrl=' + (redirect_uri || window.location.href);
        url = encodeURIComponent(url);
    }
    let appid = getAppId();
    // let url = location.href;
    // 如果是域名test-m.black-unique.com 就用wx8713a55df71d62d8
    // const flag = window.location.origin.indexOf('test-m.black-unique.com') > -1;
    // const appid = 0 ? 'wx8713a55df71d62d8' : 'wx6cd7de1c849eeeae';
    // const appid = 'wx6cd7de1c849eeeae';
    const targetUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
    return targetUrl;
}

// 获取微信的appid
function getAppId() {
    let appid = 'wxac3be0a3f6cb6872';
    let host = window.location.host;

    if (host.match(/box-m/)) {
        appid = 'wx731036a8c3a83c7c';
    } else if (host.match(/test-m/)) {
        appid = 'wxac3be0a3f6cb6872';
    }
    return appid;
}

/**
 * 检测是否登陆墙页
 *
 * @date 2019-06-17
 * @returns  true 阻止登录
 */
function checkIsLoginWallPage() {
    //特殊条件 小程序卡券列表游客模式
    if (env.isMainMiniProgram) {
        if (location.href.match(new RegExp('new/[^/]*?/(couponList)'))) {
            return true;
        }
    }
    // 如果是详情页，从不跳转登录页
    if (
        location.href.match('new/topic/views/auth/index') ||
        (location.href.match(
            new RegExp('new/[^/]*?/(detail|jdFan|tbdetail|tbDetail|hourSeckill|snDetail|freeBuy/sn|commentPage)')
        ) &&
            !/tqcz/.test(location.href)) ||
        location.href.match('new/topic/views/redirect/venueTransfer.html') ||
        location.href.match('new/topic/views/activity/coupon.html') ||
        isVisitor()
    ) {
        return true;
    }

    // 以下页面判断是否含有loginwall, 变量。没有就跳转。（从详情页点击返回首页按钮才会设置loginwall变量，主要用于推文时候，展示商品详情，以下页面不主动跳转）
    if (sessionStorage.getItem('loginwall') || (isAPP && localStorage.getItem('loginwall'))) {
        let LoginWallPages = [
            'new/[^/]*?/(mine|nearbyGoods|result|package|privilege|shop|home)([?#]|$|/$)',
            'new/[^/]*?/(pdd/detail|vip/detail|zk/|seckillActivityPage|seckillBrandPage|selectCity|setup)', // zk: 考拉,seckillActivityPage: 限时购, pdd: 拼多多, vip: 唯品会, selectCity: 地区选择, seckillBrandPage: 人气大牌
            'new/coupon/(receiveCoupon/receiveCoupon.html|list/list.html)',
            '/new/topic/views/superRedPackage/index.html#/landing',
            '/new/topic/views/activity/couponResult.html',
        ];
        let isLoginWallPage = false;

        LoginWallPages.forEach(page => {
            let result = location.href.match(new RegExp(page));
            if (result) {
                isLoginWallPage = true;
            }
        });

        return isLoginWallPage;
    } else {
        return false;
    }
}

// 减少400请求 bad requset
function lessBadRequest(url) {
    let isMatch = false;
    let urlArr = [
        'currency/v1_0/qualify',
        // 'sqb/v1_0/query',
        'collect/v1_0/addCollect',
        'currency/v2_0/info',
        'user/v1_0/getPoints',
        'order/v1_0/number',
        // 'tbk/v1_0/discern',
        '/knightCard/message/v1_0/countNotReadNum',
        'commission/v1_0/withdraw/summary', // 返现余额
        '/agent-leader/member-level', // 团长接口请求
    ];

    urlArr.forEach(item => {
        if (url.match(item)) {
            isMatch = true;
        }
    });

    return isMatch;
}

// 判断app是否开启游客模式 (假游客模式，需要登录，仅非会员)
function initLoginWall() {
    // 首页4个tab
    let LoginWallPages = [
        'new/[^/]*?/home([?#]|$|/$)',
        'new/[^/]*?/shop([?#]|$|/$)',
        'new/[^/]*?/privilege([?#]|$|/$)',
        'new/[^/]*?/package([?#]|$|/$)',
        'new/[^/]*?/mine([?#]|$|/$)',
        'new/[^/]*?/nearbyGoods([?#]|$|/$)',
    ];

    let isAppLoginWallPage = false;
    LoginWallPages.forEach(page => {
        let result = location.href.match(new RegExp(page));
        if (result) {
            isAppLoginWallPage = true;
        }
    });

    if (isAppLoginWallPage) {
        // 非app
        if (!isAPP) {
            let isHaiTao = location.href.match(/haitao=(\d)/);
            if (isHaiTao && isHaiTao.length > 1 && isHaiTao[1] != 0) {
                localStorage.setItem('isHaiTao', 1);
                sessionStorage.setItem('SET_APP_DOWNLOAD', '0');
            }

            if (location.href.match(/visitor=/)) {
                sessionStorage.setItem('loginwall', 1);
            }
        } else {
            if (location.href.match(/visitor=/)) {
                // 判断是否骑士卡登录页过来
                localStorage.removeItem('dolphin_token_from_jssdk');
                localStorage.removeItem('dolphin_token');
                localStorage.removeItem('token');
                localStorage.setItem('loginwall', 1);

                // 新版登陆墙不禁止访问我的中心
                if (!isNewVersion()) {
                    window.zzc &&
                        window.zzc.on('base_handleTab', function() {
                            EventBus.$emit('mine_login_wall', true);
                        });
                }

                // 判断原生是否带有phoneToken
                if (
                    isGreaterVersion({
                        iosMinVersion: '1.26.0',
                        androidMinVersion: '1.25.5',
                        harmonyVersion: '1.0.0',
                    })
                ) {
                    visitorGetPhoneToken();
                } else {
                    clearNativeLoginInfo();
                }
            } else {
                // 清理登录墙
                localStorage.removeItem('loginwall');
            }
        }
    }
}

// 清除原生登录信息
function clearNativeLoginInfo() {
    log('clearNativeLoginInfo 调用 account_loginSuccess');
    isNative &&
        window.zzc &&
        window.zzc.call('account_loginSuccess', {
            userID: null, // 用户id
            token: null,
            javaUserId: null,
            javaToken: null,
            success: function(response) {
                console.log('----原生登陆成功----');
                console.log(response);
            },
        });
}

// 获取phoneToken
function visitorGetPhoneToken() {
    return new Promise(resolve => {
        if (!localStorage.getItem('phoneToken')) {
            let timer = setTimeout(() => {
                resolve();
            }, 10000);
            document.addEventListener('deviceready', function() {
                if (window.zzc && window.zzcjsbridge && window.zzcjsbridge.account_getInfo) {
                    window.zzc.call('account_getInfo', {
                        success: function(response) {
                            log('account_getInfo success 1090', response);
                            if (response.data) {
                                // 打点跟踪token获取情况
                                let result = response.data;
                                if (result.phoneToken) localStorage.setItem('phoneToken', result.phoneToken);
                            }

                            clearTimeout(timer);
                            clearNativeLoginInfo();
                            resolve();
                        },
                    });
                } else {
                    clearTimeout(timer);
                    clearNativeLoginInfo();
                    resolve();
                }
            });
        } else {
            resolve();
        }
    });
}

// 可以通过 url 参数 cardLink 配置办卡链接
function initLoginWallCardLink() {
    const { cardLink } = query;

    if (!cardLink) return;

    sessionStorage.setItem('cardLink', decodeURIComponent(cardLink));
}

function resetBlackToken() {
    black_token = '';
}

export {
    request,
    linkToLogin,
    linkToWechatAuth,
    getAuthToken,
    getBlackToken,
    getToWechatAuthUrl,
    getAppId,
    initLoginWall,
    resetBlackToken,
};
